<template>
  <div v-if="leadgenFormId" class="rule-leads-view flex flex-col gap-4 py-5">
    <leadgen-form-leads-header v-if="listComponent?.leadgenForm" :list-component="listComponent" />

    <leadgen-form-leads-list
      ref="list"
      :leadgen-form-id="leadgenFormId"
      :campaign-ids="campaignIds"
      :lead-route-base="leadListPath"
    />
  </div>
</template>

<script>
import LeadModalRouteMixin from '@/mixins/LeadModalRoute.js';
import LeadgenFormLeadsHeader from '@/ui/components/LeadgenFormLeadsHeader.vue';
import LeadgenFormLeadsList from '@/ui/components/LeadgenFormLeadsList.vue';

export default {
  name: 'RuleLeadsView',
  components: {
    LeadgenFormLeadsHeader,
    LeadgenFormLeadsList,
  },
  mixins: [ LeadModalRouteMixin ],
  inject: [ 'ruleView' ],
  data: () => ({
    listComponent: null,
  }),
  computed: {
    rule() {
      return this.ruleView.rule;
    },
    leadgenFormId() {
      return this.rule?.ad_creation_details?.leadgen_form_id ?? null;
    },
    campaignIds() {
      return this.rule?.output_campaign?.id ? [ this.rule.output_campaign.id ] : null;
    },
    leadListPath() {
      return '/automation/' + this.$route.params.id + '/leads';
    },
  },
  watch: {
    leadgenFormId: {
      immediate: true,
      handler() {
        this.$nextTick(() => this.listComponent = this.$refs.list);
      },
    },
  },
};
</script>
